import React, { useEffect } from "react";
import { toast } from "react-toastify";

// styles
import styles from "./Analytics.module.scss";

// api
import { getChartData } from "../api";

// components
import PieChartComponent from "./PieChartComponent";

const Analytics = () => {
  useEffect(() => {
    // getChartData()
    //   .then((res) => {
    //     if (res.data.Status) {
    //       let count = {};
    //       res.data.Results.forEach(
    //         (item) => (count[item.State] = (count[item.State] || 0) + 1)
    //       );
    //       // console.log("state", count);
    //       console.log("states", res.data.Results);
    //     } else {
    //       toast.error(res.data.ErrorMessage);
    //     }
    //   })
    //   .catch((err) => {
    //     toast.error(err);
    //   });
  }, []);

  return (
    <div className={styles.wrapper}>
      <PieChartComponent />
    </div>
  );
};

export default Analytics;
